import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import JobFilters from './JobFilters';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { getApiBaseUrl } from '../utils/Config';

function JobSearch() {
    const [query, setQuery] = useState('');
    const [locations, setLocations] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const baseUrl = getApiBaseUrl();
    const hasMounted = useRef(false);

    const [searchQuery, setSearchQuery] = useState({
        what: searchParams.get('what') || '',
        state: searchParams.get('state') || '',
        suburb: searchParams.get('suburb') || '',
        postcode: searchParams.get('postcode') || '',
        proximity: searchParams.get('proximity') || '0',
        sponsorship: searchParams.has('sponsorship') ? searchParams.get('sponsorship') === 'true' : null, // Null if not present
        categoryId: searchParams.get('categoryId') || null,
        salaryRange: searchParams.get('salaryRange') || null,
        pageNumber: searchParams.get('pageNumber') || '1',
        remote: searchParams.has('remote') ? searchParams.get('remote') === 'true' : null, // Null if not present
    });

    useEffect(() => {
        const newQuery = {
            what: searchParams.get('what') || '',
            state: searchParams.get('state') || '',
            suburb: searchParams.get('suburb') || '',
            postcode: searchParams.get('postcode') || '',
            proximity: searchParams.get('proximity') || '0',
            sponsorship: searchParams.has('sponsorship') ? searchParams.get('sponsorship') === 'true' : null,
            categoryId: searchParams.get('categoryId') || null,
            salaryRange: searchParams.get('salaryRange') || null,
            pageNumber: searchParams.get('pageNumber') || '1',
            remote: searchParams.has('remote') ? searchParams.get('remote') === 'true' : null,
        };
        setSearchQuery(newQuery);
    }, [searchParams]);

    const commonSearches = [
        'Software Developer',
        'Frontend Developer',
        'Backend Developer',
        'Full Stack Developer',
        'DevOps Engineer',
        'Cybersecurity Analyst',
        'Systems Administrator',
        'Data Scientist',
        'Cloud Engineer',
        'IT Support',
    ];
 

    const handleCommonSearch = (jobTitle) => {
        setSelectedCategory('');
        setSearchQuery({ ...searchQuery, what: jobTitle, categoryId: null });

        const queryParams = new URLSearchParams(searchParams);
        queryParams.set('what', jobTitle);
        queryParams.delete('categoryId');
        queryParams.set('pageNumber', '1');

        navigate(`/jobs?${queryParams.toString()}`);
    };

    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [selectedSalaries, setSelectedSalaries] = useState([]);
    const [selectedEmployment, setSelectedEmployment] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const salaryOptions = [
        { label: "Under $30,000", value: 1 },
        { label: "$30,000 - $50,000", value: 2 },
        { label: "$50,000 - $70,000", value: 3 },
        { label: "$70,000 - $90,000", value: 4 },
        { label: "$90,000 - $110,000", value: 5 },
        { label: "$110,000 - $130,000", value: 6 },
        { label: "$130,000 - $150,000", value: 7 },
        { label: "$150,000 - $170,000", value: 8 },
        { label: "$170,000 - $190,000", value: 9 },
        { label: "$190,000 - $210,000", value: 10 },
        { label: "$210,000 - $230,000", value: 11 },
        { label: "$230,000 - $250,000", value: 12 },
        { label: "$250,000 and above", value: 13 },
        { label: "Negotiable", value: 14 },
        { label: "Competitive", value: 15 },
    ];

    const employmentOptions = [
        { label: 'Full-Time', value: 1 },
        { label: 'Part-Time', value: 2 },
        { label: 'Casual', value: 3 },
        { label: 'Contract', value: 4 },
        { label: 'Temporary', value: 5 },
        { label: 'Freelance', value: 6 },
        { label: 'Internship', value: 7 },
        { label: 'Consultancy', value: 8 },
        { label: 'Apprenticeship', value: 9 },
    ];

    const categoryOptions = [
        { label: 'Artificial Intelligence and Machine Learning', value: 1 },
        { label: 'Business Intelligence and Data Analysis', value: 2 },
        { label: 'Cloud Computing and Architecture', value: 3 },
        { label: 'Cybersecurity and Information Security', value: 4 },
        { label: 'Database Administration and Development', value: 5 },
        { label: 'Data Science and Analytics', value: 6 },
        { label: 'DevOps Engineering', value: 7 },
        { label: 'Executive Leadership (e.g., CIO, CTO)', value: 8 },
        { label: 'IT Consulting and Strategy', value: 9 },
        { label: 'IT Education and Training', value: 10 },
        { label: 'IT Management', value: 11 },
        { label: 'IT Project Management', value: 12 },
        { label: 'IT Research and Development', value: 13 },
        { label: 'IT Support and Helpdesk', value: 14 },
        { label: 'Mobile Application Development', value: 15 },
        { label: 'Network and Infrastructure', value: 16 },
        { label: 'Quality Assurance and Testing', value: 17 },
        { label: 'Software Development and Engineering', value: 18 },
        { label: 'System Administration', value: 19 },
        { label: 'Technical Writing and Documentation', value: 20 },
        { label: 'UI/UX Design', value: 21 },
        { label: 'Web Development and Design', value: 22 },
    ];

    const fetchLocations = async (searchTerm) => {
        if (!searchTerm) {
            setLocations([]);
            return;
        }

        try {
            const response = await axios.get(`${baseUrl}/api/LookUp/GetLocationSearchJob`, {
                params: {
                    postcode: searchTerm,
                    suburb: searchTerm,
                    state: searchTerm,
                },
            });
            setLocations(response.data.result || []);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (query.length >= 3) {
                fetchLocations(query);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [query]);

    const handleSelectLocation = (selectedLocation) => {
        setSearchQuery({
            ...searchQuery,
            state: selectedLocation.State,
            suburb: selectedLocation.Suburb,
            postcode: selectedLocation.Postcode,
        });
        setQuery(`${selectedLocation.Suburb}, ${selectedLocation.State} (${selectedLocation.Postcode})`);
        setShowDropdown(false);
    };


    const handleInputChange = (event) => {
        setQuery(event.target.value);
        setShowDropdown(true);
    };

    const buildQueryParams = () => {
        const queryParams = new URLSearchParams();

        if (searchQuery.what) queryParams.append('what', searchQuery.what);
        if (searchQuery.salaryRange) queryParams.append('salaryRange', searchQuery.salaryRange);
        if (selectedEmployment.length) queryParams.append('worktype', selectedEmployment.join(','));
        if (searchQuery.postcode) queryParams.append('postcode', searchQuery.postcode);
        if (searchQuery.state) queryParams.append('state', searchQuery.state);
        if (searchQuery.suburb) queryParams.append('suburb', searchQuery.suburb);
        if (searchQuery.proximity && searchQuery.proximity !== '0') queryParams.append('proximity', searchQuery.proximity);
        if (searchQuery.sponsorship !== null) queryParams.append('sponsorship', searchQuery.sponsorship);
        if (searchQuery.remote !== null) queryParams.append('remote', searchQuery.remote);
        if (selectedCategory) queryParams.append('categoryId', selectedCategory);

        return queryParams;
    };

    const updateQueryParams = () => {
        const queryParams = buildQueryParams();
        queryParams.set('pageNumber', '1');
        navigate(`/jobs?${queryParams.toString()}`, { replace: true });
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        const queryParams = buildQueryParams();
        queryParams.set('pageNumber', '1');
        navigate(`/jobs?${queryParams.toString()}`);
    };
    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return; // skip running on first render
        }

        const debounce = setTimeout(() => {
            updateQueryParams(); // only triggered on filter change
        }, 400);

        return () => clearTimeout(debounce);
    }, [
        searchQuery.salaryRange,
        searchQuery.sponsorship,
        searchQuery.remote,
        searchQuery.categoryId,
        selectedEmployment,
        selectedCategory,
    ]);


    return (
        <div className="search-section-desk">
            <div className="search-section-inner-grb">
                <div className="container-fluid container-index-w234">
                    <div className="search-section-vt">
                        <h1 className="search-section-hd css-sc-hd">
                           Upgrade your <span className="css-sc-hd_21">tech</span> career.
                        </h1>
                        <div className="search-section-sb-outer">
                            {/*Desktop Search*/}
                            <form className="search-section-vt-form-al" onSubmit={handleSubmit}>
                                <div className="search-section-vt-form-int pasdk_slk">
                                    <div className="search-section-vt-form-what">
                                        <div className="input-group input-group-lg input-group-inline mb-1">
                                            <span className="input-group-text fontWeightS">What</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Job Title or Keyword"
                                                name="what"
                                                value={searchQuery.what}
                                                onChange={(e) =>
                                                    setSearchQuery({ ...searchQuery, what: e.target.value })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="search-section-vt-form-where position-relative">
                                        <div className="input-group input-group-lg input-group-inline mb-1">
                                            <span className="input-group-text fontWeightS">Where</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter suburb, state, or postcode"
                                                value={query}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        {showDropdown && locations.length > 0 && (
                                            <ul className="dropdown-menu show">
                                                {locations.map((location) => (
                                                    <li
                                                        key={location.LocationID}
                                                        className="dropdown-item"
                                                        onClick={() => handleSelectLocation(location)}
                                                    >
                                                        {`${location.Suburb}, ${location.State} (${location.Postcode})`}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    <div className="search-section-vt-form-button">
                                        <button type="submit" className="btn btn-primary btn-lg">
                                            <span className="ssri-subbut-inner-span ssri-subbut-inner-sub">
                                                <i className="bi bi-search"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div className="common-searches mb-3">
                                    <p className="common-search-title">Popular Searches:</p>
                                    <div className="common-search-buttons">
                                        {commonSearches.map((job) => (
                                            <button
                                                key={job}
                                                className="btn btn-stack-tal me-2 mb-2"
                                                onClick={() => handleCommonSearch(job)}
                                            >
                                                {job}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <JobFilters
                                    isMobile={false}
                                    searchQuery={searchQuery}
                                    setSearchQuery={setSearchQuery}
                                    selectedEmployment={selectedEmployment}
                                    setSelectedEmployment={setSelectedEmployment}
                                    selectedSalaries={selectedSalaries}
                                    setSelectedSalaries={setSelectedSalaries}
                                    selectedCategory={selectedCategory}
                                    setSelectedCategory={setSelectedCategory}
                                    salaryOptions={salaryOptions}
                                    employmentOptions={employmentOptions}
                                    categoryOptions={categoryOptions}
                                />

                              
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobSearch;
